import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Sidebar from '../SideBar/SideBar';
import { Outlet, useLocation } from 'react-router-dom';
import './Layout.css';
import { Suspense, useState } from 'react';
import LoadingOverlay from '../Custom/LoadingOverlay';
import MenuPopup from './MenuPopup';
import useGroupMessaging from '../../customHooks/globalCustomHooks/useGroupMessaging';
import useOneOnOneMessaging from '../../customHooks/globalCustomHooks/useOneOnOneMessaging';
import useFetchUnreadMsgChatRoomsCount from '../../customHooks/globalCustomHooks/useFetchUnreadMsgChatRoomsCount';
import useNoteOneOnOneMessagingEvents from '../../customHooks/socketEvents/noteOneOnOneMessaging/useNoteOneOnOneMessagingEvents';
import { useSelector } from 'react-redux';
import useNoteOneOnOneSetupEvents from '../../customHooks/socketEvents/noteOneOnOneMessaging/useNoteOneOnOneSetupEvents';
import SupportAgentAlerts from '../Others/SupportAgentAlerts';

const Layout = () => {
  const { eventInfo, eventNotesAssignUser } = useSelector((state) => state.eventRequestDetails);

  // custom hooks start...
  // group messaging custom hooks...
  useGroupMessaging();
  // group messaging custom hooks...

  // oneOnOne messaging custom hooks...
  useOneOnOneMessaging();
  // oneOnOne messaging custom hooks...

  // fetchUnreadMsgChatRoomsCount hooks...
  useFetchUnreadMsgChatRoomsCount();
  // fetchUnreadMsgChatRoomsCount hooks...

  // note socket event listener custom hook...
  useNoteOneOnOneMessagingEvents({
    roomIds: eventNotesAssignUser?.[0]?.chatId ? [eventNotesAssignUser?.[0]?.chatId] : [''],
    eventInfo,
  });

  useNoteOneOnOneSetupEvents();
  // note socket event listener custom hook...
  // custom hooks end...

  return (
    <>
      <SupportAgentAlerts />
      <LayoutFrame />
    </>
  );
};

/** Shared visual frame without mounting the administrative messaging hooks. */
export const LayoutFrame = ({ accountOnly = false }) => {
  const [toggleSideBarData, setToggleSideBarData] = useState({
    open: true,
    priorityOpen: false,
  });
  const { pathname } = useLocation();

  return (
    <Box>
      {/* <NavBar /> */}
      <Box
        sx={{
          padding: '40px',
          display: 'flex',
          gap: '16px',
          alignItems: 'flex-start',
          '@media (max-width: 1200px)': {
            flexDirection: 'column',
            paddingTop: '20px',
            '& > div:first-of-type': {
              display: 'none',
            },
          },
          '@media (max-width: 600px)': {
            padding: '15px',
          },
        }}
      >
        <Sidebar
          accountOnly={accountOnly}
          toggleSideBarData={toggleSideBarData}
          setToggleSideBarData={setToggleSideBarData}
        />
        <MenuPopup
          path={accountOnly ? (pathname === '/profile' ? 'Profile' : 'Media Gallery') : undefined}
        >
          <Sidebar accountOnly={accountOnly} />
        </MenuPopup>
        <Box
          data-route-scroll-root
          onClick={(e) => {
            // e.stopPropagation();
            if (!toggleSideBarData.priorityOpen) {
              setToggleSideBarData({ ...toggleSideBarData, open: false });
            }
          }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flex: '1',
            width: '100%',
            borderRadius: '16px',
            padding: '0',
            border: '2px solid #D175B6',
            background: 'rgba(0, 0, 0, 0.50)',
            // background: "red",
            minHeight: 'calc(100vh - 204px)',
            // minWidth: "calc(100vw - 396px)",
            overflow: 'scroll',
            '&::-webkit-scrollbar': {
              width: 0, // Hide scrollbar on WebKit browsers (e.g., Chrome, Safari)
            },
            scrollbarWidth: 'none', // Hide scrollbar on Firefox
            // Add other styles as needed
          }}
        >
          <Suspense fallback={<LoadingOverlay open={true} />}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;

Layout.propTypes = {
  children: PropTypes.node,
};

LayoutFrame.propTypes = { accountOnly: PropTypes.bool };
